import React from 'react';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import PF2MFullScreenButton from '~/components/PF2MFullScreenButton';
import CleanFilterIcon from '~/assets/clean_filter.svg';
import PF2MIconButton from '~/components/PF2MIconButton';
import { InfoOutlined } from '@material-ui/icons';

const FIELDS = [
  {
    key: 'id_unitary_operation_group',
    label: 'Grupo de Operação Unitária',
    type: 'select',
    optionsKey: 'unitOperationGroupOpts',
  },
  {
    key: 'id_project_group',
    label: 'Grupo de Projeto',
    type: 'select',
    optionsKey: 'projectGroupOpts',
  },
  {
    key: 'priority',
    label: 'Prioridade',
    type: 'select',
    optionsKey: 'priorityOpts',
  },
  {
    key: 'id_element',
    label: 'Elemento',
    type: 'select',
    optionsKey: 'elementOpts',
  },
  {
    key: 'element_point_name',
    label: 'Sub-Elemento',
    type: 'text',
    placeholder: 'Buscar...',
  },
  {
    key: 'id_code_type_ug',
    label: 'Tipo de Código',
    type: 'select',
    optionsKey: 'codeTypeOpts',
  },
  {
    key: 'id_code_group_ug',
    label: 'Grupo de Código',
    type: 'select',
    optionsKey: 'codeGroupOpts',
  },
  {
    key: 'code_ug_name',
    label: 'Código',
    type: 'text',
    placeholder: 'Buscar...',
  },
];

export default function KanbanFilters({
  values = {},
  onChange,
  onClear,
  options = {},
  dense = true,
  style,
  hiddenKeys = [],
  isFullScreenActive,
  menuContainerEl,
  order,
  handleInfoModal,
}) {
  const handle = name => e => onChange && onChange(name, e.target.value);

  const fieldCommon = {
    variant: 'outlined',
    size: dense ? 'small' : 'medium',
    fullWidth: true,
    SelectProps: {
      MenuProps: {
        container: menuContainerEl || document.body,
        getContentAnchorEl: null,
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
        PaperProps: {
          style: {
            maxHeight: 350,
            zIndex: 2000,
          },
        },
      },
    },
    InputProps: {
      style: {
        borderRadius: '12 12 0 0',
        background: '#fff',
        maxHeight: 200,
      },
    },
  };

  const defaultOptions = {
    unitOperationGroupOpts: [
      { label: 'Lavra', value: 1 },
      { label: 'Desenvolvimento', value: 2 },
      { label: 'Infraestrutura', value: 3 },
      { label: 'Transporte', value: 4 },
      { label: 'Inspeção', value: 5 },
    ],

    projectGroupOpts: [
      { label: 'Todos', value: null },
      { label: 'Projeto A', value: 1 },
      { label: 'Projeto B', value: 2 },
    ],

    priorityOpts: [
      { label: 'Todos', value: null },
      { label: '0', value: 0 },
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: 3 },
      { label: '4', value: 4 },
      { label: '5', value: 5 },
      { label: '6', value: 6 },
      { label: '7', value: 7 },
      { label: '8', value: 8 },
      { label: '9', value: 9 },
    ],

    elementOpts: [
      { label: 'Todos', value: null },
      { label: 'D515', value: 1 },
      { label: 'C214', value: 2 },
      { label: 'E403', value: 3 },
      { label: 'B112', value: 4 },
      { label: 'B112', value: 5 },
      { label: 'F290', value: 6 },
    ],

    codeTypeOpts: [
      { label: 'Todos', value: null },
      { label: 'Parada', value: 1 },
      { label: 'Operando', value: 2 },
    ],

    codeGroupOpts: [
      { label: 'Todos', value: null },
      { label: 'Operação Lavra', value: 1 },
      { label: 'Operação Desenv', value: 2 },
      { label: 'Processo', value: 3 },
    ],
  };

  const byKey = Object.fromEntries(FIELDS.map(f => [f.key, f]));
  const orderedKeys = order && order.length ? order : FIELDS.map(f => f.key);

  const fieldsToRender = orderedKeys
    .map(k => byKey[k])
    .filter(Boolean)
    .filter(f => !hiddenKeys.includes(f.key));

  return (
    <Box
      bgcolor="white"
      style={style}
    >
      <Box display="flex" flexWrap="wrap" alignItems="center" m={-1}>
        {fieldsToRender.map((f) => {
          const value = values[f.key] ?? '';
          const isSelect = f.type === 'select';
          const opts = isSelect
            ? (options[f.optionsKey] || defaultOptions[f.optionsKey] || [])
            : [];

          return (
            <Box key={f.key} p={1} flex="1 1 200px" minWidth={180}>
              <TextField
                label={f.label}
                select={isSelect}
                value={value}
                onChange={handle(f.key)}
                placeholder={f.placeholder}
                {...fieldCommon}
              >
                {isSelect
                  ? opts.map(opt => (
                    <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                  ))
                  : null}
              </TextField>
            </Box>
          );
        })}

        <Box p={1} flex="0 0 auto" display="flex" alignItems="center">
          <PF2MIconButton
            icon={(
              <img
                src={CleanFilterIcon}
                alt=""
              />
            )}
            onClick={onClear}
            variant="filled"
          />
        </Box>

        <Box p={1} flex="0 0 auto" display="flex" alignItems="center">
          <PF2MIconButton
            icon={<InfoOutlined fontSize="small" />}
            onClick={handleInfoModal}
          />
        </Box>

        {isFullScreenActive && (
          <Box p={1} flex="0 0 auto" display="flex" alignItems="center">
            <Tooltip title="Expandir filtros">
              <PF2MFullScreenButton
                isFullScreenActive={isFullScreenActive.active}
                open={isFullScreenActive.enter}
                close={isFullScreenActive.exit}
                variant="outlined"
              />
            </Tooltip>
          </Box>
        )}
      </Box>
    </Box>
  );
}
